module.exports = __webpack_public_path__ + "media/components/payment_slip/uplatnica-b23b9e900bae381a544e712584db1304.gif";